import * as React from "react";
import { forwardRef } from "react";
const SvgChevronUp = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M17 15L12 10L7 15", stroke: "#1A2023", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgChevronUp);
export { ForwardRef as ReactComponent };
